import React, { Component } from 'react'
import NavItemsList from './NavItemsList'
import {
  INavigationProps,
  INavigationState,
} from '../../../interfaces/Navigation.Interface'
import SecondaryNavItemsList from './SecondaryNavItemsList'
import SocialNavItemsList from './SocialNavItemsList'
import { Header } from '../header/Header'
import { HeaderOverlay } from '../header/HeaderOverlay'
import { Translator } from '../header/Translator'
import { Search } from '../header/Search'
import { MiniFooterLayout } from '../layouts/MiniFooterLayout'
import { MainNavLayout } from '../layouts/MainNavLayout'

export class NavigationHeader extends Component<
  INavigationProps,
  INavigationState
> {
  constructor(props) {
    super(props)
  }

  state: INavigationState = {
    showBanner: true,
    clicked: false,
    translatorClicked: false,
    searchClicked: false,
    showMainandFooter: true,
  }

  dispatchClickEvent(value) {
    this.props.headerClick(!value)
  }

  menuHandleClick = (e) => {
    e.preventDefault()
    this.setState({ showBanner: this.state.clicked })
    this.setState({ clicked: !this.state.clicked })
    this.dispatchClickEvent(this.state.clicked)
  }

  menuHandleTranslatorClick = (e) => {
    e.preventDefault()
    this.setState({ clicked: !this.state.clicked })
    this.setState({ translatorClicked: true })
    this.setState({ searchClicked: false })
    this.dispatchClickEvent(false)
  }

  menuHandleSearchClick = (e) => {
    e.preventDefault()
    this.setState({ clicked: !this.state.clicked })
    this.setState({ translatorClicked: false })
    this.setState({ searchClicked: true })
    this.dispatchClickEvent(this.state.clicked)
  }

  handleTranslatorClick = (e) => {
    e.preventDefault()
    if (this.state.translatorClicked) {
      return
    }
    this.setState({ showBanner: this.state.translatorClicked })
    this.setState({ translatorClicked: !this.state.translatorClicked })
    this.dispatchClickEvent(this.state.clicked)
  }

  handleTranslatorCloseClick = (e) => {
    e.preventDefault()
    this.setState({ showBanner: this.state.translatorClicked })
    this.setState({ translatorClicked: !this.state.translatorClicked })
    this.dispatchClickEvent(true)
  }

  handleSearchClick = (e) => {
    e.preventDefault()
    if (this.state.searchClicked) {
      return
    }
    this.setState({ showBanner: this.state.searchClicked })
    this.setState({ translatorClicked: this.state.searchClicked })
    this.setState({ searchClicked: !this.state.searchClicked })
    this.dispatchClickEvent(this.state.clicked)
  }

  searchHandleTranslatorClick = (e) => {
    e.preventDefault()
    this.setState({ showBanner: this.state.translatorClicked })
    this.setState({ translatorClicked: true })
    this.setState({ searchClicked: false })
    this.dispatchClickEvent(true)
  }

  searchHandleCloseClick = (e) => {
    e.preventDefault()
    this.setState({ showBanner: true })
    this.setState({ translatorClicked: false })
    this.setState({ searchClicked: false })
    this.dispatchClickEvent(true)
  }

  render() {
    return (
      <>
        <Header
          id="header"
          active={
            this.state.clicked ||
            this.state.translatorClicked ||
            this.state.searchClicked
          }
          showMegamenu={this.props.showMegamenu}
          openClick={this.menuHandleClick}
          translatorClick={this.handleTranslatorClick}
          searchClick={this.handleSearchClick}
        />

        <HeaderOverlay
          id="main-menu-overlay"
          active={this.state.clicked}
          closeClick={this.menuHandleClick}
          translatorClick={this.menuHandleTranslatorClick}
          searchClick={this.menuHandleSearchClick}
        >
          <MainNavLayout>
            <NavItemsList navItems={this.props.primary} id="main" />
          </MainNavLayout>

          <MiniFooterLayout>
            <SecondaryNavItemsList navItems={this.props.secondary} id="sec" />
            <SocialNavItemsList navItems={this.props.social} id="soc" />
          </MiniFooterLayout>
        </HeaderOverlay>
        <HeaderOverlay
          id="translator-overlay"
          active={this.state.translatorClicked}
          translatorClick={this.handleTranslatorClick}
          closeClick={this.handleTranslatorCloseClick}
          searchClick={this.handleSearchClick}
        >
          <Translator />
        </HeaderOverlay>

        <HeaderOverlay
          id="search-overlay"
          active={this.state.searchClicked}
          translatorClick={this.searchHandleTranslatorClick}
          closeClick={this.searchHandleCloseClick}
          searchClick={this.handleSearchClick}
        >
          <Search />
        </HeaderOverlay>
      </>
    )
  }
}
